import React from 'react';
import FamilyMembersSearch from './FamilyMembersSearch';
import MembersSortControls from './MembersSortControls';
import type { FilterType } from './FamilyMembersFilterBar';
import type { MembersSortBy, MembersSortDirection } from '@/types/members-list';

interface MembersSearchSortRowProps {
  filter: FilterType;
  searchQuery: string;
  onSearchChange: (query: string) => void;
  sortBy: MembersSortBy;
  sortDirection: MembersSortDirection;
  onSortByChange: (sort: MembersSortBy) => void;
  onSortDirectionChange: (direction: MembersSortDirection) => void;
}

const MembersSearchSortRow: React.FC<MembersSearchSortRowProps> = ({
  filter,
  searchQuery,
  onSearchChange,
  sortBy,
  sortDirection,
  onSortByChange,
  onSortDirectionChange
}) => (
  <div className="list-search-row members-search-row">
    <FamilyMembersSearch value={searchQuery} onChange={onSearchChange} />
    {filter !== 'pets' && (
      <MembersSortControls
        sortBy={sortBy}
        sortDirection={sortDirection}
        onSortByChange={onSortByChange}
        onSortDirectionChange={onSortDirectionChange}
      />
    )}
  </div>
);

export default MembersSearchSortRow;
